import { Position } from './position.model';

export class GeoBoundBox {

  public bottomLeft: Position;
  public topRight: Position;

  constructor(obj?: Partial<GeoBoundBox>) {
    Object.assign(this, obj);
  }

}
